import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { PayeePopupModule } from 'src/app/shared/payee-popup/payee-popup.module';
import { PayeeButtonsModule } from 'src/app/shared/payee-buttons/payee-buttons.module';

import { GenerateAttorneyDataDialogComponent } from './generate-attorney-data-dialog.component';
import { ValidationErrorsComponent } from './validation-errors/validation-errors.component';
import { MatDialogModule } from '@angular/material/dialog';
import { PayeeIconModule } from '../../payee-icon/payee-icon.module';

@NgModule({
  declarations: [
    GenerateAttorneyDataDialogComponent,
    ValidationErrorsComponent
  ],
  imports: [
    CommonModule,
    PayeePopupModule,
    PayeeButtonsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    PayeeIconModule,
  ]
})
export class GenerateAttorneyDataDialogModule { }